export const blur = {
  s: { value: '8px' },
};
